export default __webpack_public_path__ + "9169c7ab05253f7531ea1affb917daf7.png";